 <template>
  <div :class="$store.getters.platform === 'browser' ? 'page-bg-browser' : 'page-bg'" v-bg="{image: category.background, alternative: true, dir: 'to right'}">
    <video-bg v-if="category.trailer && locked" :src="category.trailer" :autoplay="true"></video-bg>

    <app-loader v-if="loading"></app-loader>
    <div v-else>

      <div v-if="!locked" class="wrapper-grid">
        <Grid
          :options = "{
            type: !category.is_final ? 'card-categories' : 'card-contents',
            title: category.name,
            items: !category.is_final ? category.child_categories : category.category_content,
            route: !category.is_final ? 'content-category' : 'content-detail',
            card: category.card,
          }"
        />
      </div>

      <!-- category detail -->
      <div  v-else :id="'cat-' + category.id" class="wrapper-detail">
        <div class="img">
          <img :src="$store.getters.getData.logo_mono">
        </div>
        <div class="text">
          <h2 class="text-black-shadow">{{category.name}}</h2>
          <p class="text-black-shadow"><pre>{{category.description | truncateText(600) }}</pre></p>

          <!-- <a v-if="category.trailer" v-on:click="trailer" v-on:keyup.enter="trailer" class="waves-effect waves-light btn-large focusable" tabindex="-1">Trailer</a> -->

          <p v-if="lockedAdmin" class="text-black-shadow" style="margin-bottom: .5rem;">{{ $t("CONTENT-DETAIL.MSG-ADMIN") }}</p>
          <a v-else v-on:click="purchase" v-on:keyup.enter="purchase" class="waves-effect waves-light btn-large focusable" tabindex="-1">{{price | currencyFormatter(currency)}}</a>

        </div>
        <!-- <div class="locked bg-white-opacity text-black-shadow"><icon name="lock" scale="5"></icon></div> -->
        <!-- <Modal v-if="showModal" @close="closeModal">
          <p slot="body">{{$i18n.t('GENERAL.REQUIERE-LINK')}}</p>
        </Modal> -->
        <Modal v-if="showModal" @close="closeModal">
          <!-- modal dialog -->
          <p v-if="showModal === 'dialog'" slot="body">{{textDialog}}</p>

          <!-- modal no user -->
          <Login v-if="showModal === 'no-user'"
            slot="body"
            :title="''"
            :redirect="false"
            @onLogin="loggedIn"
          />
          <a v-if="showModal === 'no-user'" slot="footer" @click="closeModal" v-on:keyup.enter="closeModal" class="waves-effect waves-light btn-large modal-focusable" tabindex="-1">{{ $t("GENERAL.CANCEL") }}</a>
        </Modal>

      </div>

    </div>
  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import SpatialNavigation from 'js-spatial-navigation'
import List from '@/components/List'
import Grid from '@/components/Grid'
import VideoBg from '@/components/video-bg'
import Modal from '@/components/Modal'
import Login from '@/components/Login'
import {StatsCategoryDetail, StatsContentCategory} from '@/utils/constants'
import { setLocation, getLocation } from '@/utils/helper-functions'
const contentsService = require('@/services/contents.js')

export default {
  name: 'ContentCategory',
  components: {
    'app-loader': Loader,
    'app-list': List,
    'video-bg': VideoBg,
    Modal,
    Login,
    Grid
  },
  data () {
    return {
      category: {},
      items: [],
      showModal: false
      // toast: null
    }
  },
  created: function () { this.getGeolocation() },
  mounted: function () {
    // control keys
    Bus.$on('key-back', this.keyBack)
  },
  methods: {
    getGeolocation () {
      let location = getLocation(this.$store.getters.getData.is_zones)
      if (location) {
        this.getCategory(location.lat, location.lon)
      } else {
        if (navigator.geolocation && !window.webOS) {
          // obtenemos geolocalización (LG no lo permite)
          let options = {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: Infinity
          }
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setLocation({lat: position.coords.latitude, lon: position.coords.longitude})
              this.getCategory(position.coords.latitude, position.coords.longitude)
            },
            () => { this.getCategory(0, 0) },
            options)
        } else {
          this.getCategory(0, 0)
        }
      }
    },
    getCategory (lat, lon) {
      // CATEGORÍA
      contentsService.getCategory(this.$route.params.id, lat, lon).then(response => {
        this.category = response.data

        // metas
        // document.title = this.category.name
        // document.querySelector('meta[name="Description"]').setAttribute('content', this.category.description.slice(0, 100))

        if (!this.locked) {
          // mostramos categoría
          !this.category.is_final ? this.items = this.category.child_categories : this.items = this.category.category_content
          // stats content category
          window.Countly.q.push(['track_pageview', StatsContentCategory + ' ' + this.category.id + ': ' + this.category.name])
        } else {
          // iniciamos controles
          setTimeout(() => { this.initControls() }, 0)
          // stats category detail
          window.Countly.q.push(['track_pageview', StatsCategoryDetail + ' ' + this.category.id + ': ' + this.category.name])
        }
      })
    },
    initControls () {
      this.SN = SpatialNavigation.add({selector: '#cat-' + this.category.id + ' .focusable', restrict: 'self-only'})
      SpatialNavigation.makeFocusable()

      SpatialNavigation.focus(this.SN)
      SpatialNavigation.resume()
    },
    onClick: function (id) {
      let type
      this.category.is_final ? type = 'content-detail' : type = 'content-category'
      this.$router.push({name: type, params: {id: id}})
    },
    trailer () { this.$router.push({name: 'category-trailer', params: { id: this.category.id }}) },
    purchase () {
      if (!this.$store.getters.user) {
        if (this.$store.getters.platform !== 'browser') {
          this.showModal = 'no-user'
        } else {
          this.textDialog = this.$i18n.t('GENERAL.REQUIERE-LINK')
          this.showModal = 'dialog'
        }
      } else {
        this.$store.commit('setPurchase', {
          type: 'cat',
          id: this.category.id,
          'inna': this.category.inapppurchase.id,
          'price': this.category.inapppurchase.price
        })
        this.$router.push({name: 'purchase-summary-content'})
      }
    },
    keyBack: function () { if (!document.getElementById('app-modal')) { this.$router.go(-1) } },
    closeModal: function () {
      this.showModal = false
      SpatialNavigation.focus(this.SN)
    },
    loggedIn: function () {
      this.textDialog = this.$i18n.t('LOGIN.WELCOME')
      this.showModal = 'dialog'
    }
  },
  computed: {
    loading: function () {
      return Object.keys(this.category).length === 0
    },
    locked: function () {
      return this.category.is_premium && !this.category.is_paid
    },
    lockedAdmin: function () {
      return this.category.is_premium && !this.category.is_paid && this.category.inapppurchase.is_manual
    },
    listType: function () {
      let type = ''
      !this.category.is_final ? type = 'card-categories' : type = 'card-contents'
      return type
    },
    listRoute: function () {
      let route = ''
      !this.category.is_final ? route = 'content-category' : route = 'content-detail'
      return route
    },
    price: function () {
      return (this.$store.getters.user && this.$store.getters.user.country2) ? this.category.inapppurchase.price * this.$store.getters.user.exchange : this.category.inapppurchase.price
    },
    currency: function () {
      return (this.$store.getters.user && this.$store.getters.user.country2) ? this.$store.getters.user.country2.currency : this.$store.getters.getData.currency
    }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
    if (this.SN) SpatialNavigation.remove(this.SN)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>

.wrapper-grid
  position: relative;
  height: 100vh;
  margin-top: 1rem;

.wrapper-detail
  position: relative;
  width: 100vw;
  height: 100vh;

  .img
    float: right;
    max-width: 22vw;
    max-height: inherit;
    padding-right: 2rem;
    min-width: 156px;

    img
      max-width: 100%;
      height: auto;
      max-height: inherit;

  .text
    max-width: 60%;
    min-height: 57vh;
    min-width: 300px;
    clear: both;
    color: white;
    padding: 1rem;
    margin-left: 2rem;

    h2
      font-size: 2.3rem;
      font-weight: 500;
      margin: 0 0 .3rem 0!important;
      word-wrap: break-word;

    p
      font-size: 1.4rem;
      line-height: 1.4;
      margin: 0 0 .3rem 0;

      pre
        white-space: pre-wrap
        font-family: "Roboto"

  .locked
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 30vh;
    font-size: 1.5rem;
    text-align: center;
    padding-top: 2rem;

  hr
    height: .3rem!important;
    display: block;
    padding: 0;
    margin: 0;
    height: 0;
    border: 0;
</style>



// WEBPACK FOOTER //
// src/templates/default/contents/content-category.vue